export default __webpack_public_path__ + "30ade5c9431eb9914c075f763a46423a.png";